export default __webpack_public_path__ + "static/2000_2010-99e7d8cb8c1e666c474ff1c626283539.mp4";